import { updateCartItem } from "../resources/shopify-cart";
import { slideClosed } from "../utilities/animations";
import { cart } from "./cart";

const cartItems = document.querySelector('[data-element="cart-items"]');

const handleQuantityChanged = (event) => {
	if (!event.target.closest('[data-element="quantity-input"]')) return;

	event.preventDefault();
	const element = event.target.closest('[data-element="quantity-input"]');
	const cartItemComponent = element.closest('[data-component="cart-item"]');
	const quantity = parseInt(element.value);

	updateCartItem(cartItemComponent.getAttribute("data-key"), quantity).then(
		function (cartData) {
			cart.render(cartData);
		},
	);
};

const handleRemoveItem = (event) => {
	console.log("handle remove item - was clicked");
	if (!event.target.closest('[data-action="remove-item"]')) return;

	console.log("handle remove item - will run");

	event.preventDefault();
	const cartItemComponent = event.target.closest(
		'[data-component="cart-item"]',
	);

	// Begin hiding item while it saves back to server
	cartItemComponent.style.opacity = "0";
	cartItemComponent.style.transform = "scale(0.97)";

	updateCartItem(cartItemComponent.getAttribute("data-key"), 0).then(
		function (data) {
			if (data == "Error") {
				// Reset item, it stays in cart
				cartItemComponent.style.opacity = "1";
				cartItemComponent.style.transform = "scale(1)";
				setTimeout(function () {
					alert(
						"There was an erorr communicating with the server. Please contact us if you continue to have problems with your cart.",
					);
				}, 400);
				return;
			}

			slideClosed(cartItemComponent);

			setTimeout(function () {
				cart.render(data);
			}, 500);
		},
	);
};

if (cartItems) {
	cartItems.addEventListener("change", handleQuantityChanged);
	cartItems.addEventListener("click", handleRemoveItem);
}
